/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_Available_BodyInputs */

const en_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version of Closed Caption Creator is available.`)
};

const fr_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une nouvelle version de Closed Caption Creator est disponible.`)
};

const de_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Version von Closed Caption Creator ist verfügbar.`)
};

const it_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È disponibile una nuova versione di Closed Caption Creator.`)
};

const ru_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступна новая версия программы для создания субтитров.`)
};

const es_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya está disponible una nueva versión de Closed Caption Creator.`)
};

const zh_cn2_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新版字幕创建工具现已推出。`)
};

const ja_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator の新しいバージョンが利用可能です。`)
};

const hi_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर का नया संस्करण उपलब्ध है।`)
};

const pt_pt2_update_available_body = /** @type {(inputs: Update_Available_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma nova versão do Closed Caption Creator está disponível.`)
};

/**
* | output |
* | --- |
* | "A new version of Closed Caption Creator is available." |
*
* @param {Update_Available_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_available_body = /** @type {((inputs?: Update_Available_BodyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_Available_BodyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_available_body(inputs)
	if (locale === "de") return de_update_available_body(inputs)
	if (locale === "it") return it_update_available_body(inputs)
	if (locale === "ru") return ru_update_available_body(inputs)
	if (locale === "es") return es_update_available_body(inputs)
	if (locale === "zh-CN") return zh_cn2_update_available_body(inputs)
	if (locale === "ja") return ja_update_available_body(inputs)
	if (locale === "hi") return hi_update_available_body(inputs)
	if (locale === "pt-PT") return pt_pt2_update_available_body(inputs)
	return en_update_available_body(inputs)
});